export default __webpack_public_path__ + "pgnv-assets/a6b84b7ff7563622b3587312b464cb3d.png";